import LocalAsyncStore from '../../local-async-store'
import PaymentsView from './views'

export const PaymentDetails = PaymentsView

export const apiEndPoint = ({ record }) => `/api/session-summaries/${record.id}/payments`

export default LocalAsyncStore('payments', PaymentDetails, apiEndPoint)



// WEBPACK FOOTER //
// ./src/payments/details/container.js